<template>
  <div class="image-gallery">
    <el-tabs v-model="activeTab" type="card">
      <el-tab-pane label="专利证书" name="patent">
        <image-section :images="patentImages" />
      </el-tab-pane>
      <el-tab-pane label="软件著作" name="software">
        <image-section :images="softwareImages" />
      </el-tab-pane>
      <el-tab-pane label="文章成果" name="article">
        <image-section :images="articleImages" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ImageSection from "./ImageSection.vue";

export default {
  name: "ImageGallery",
  components: {
    ImageSection,
  },
  props: {
    patentImages: {
      type: Array,
      default: () => [],
    },
    softwareImages: {
      type: Array,
      default: () => [],
    },
    articleImages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeTab: "patent",
    };
  },
};
</script>

<style scoped>
.image-gallery {
  padding: 20px;
  height: 550px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>